<template lang="html">
  <div id="service-page">

    <section class="main-section">
      <div class="container">
        <div class="row">
          <!-- <div class="col-lg-12 col-banner">
            <div class="image">
              <div class="placed-backg img-fake" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/banner-3.jpg)' }"></div>
              <img src="public/images/pages/services/banner-3.jpg">
            </div>
          </div> -->

          <div class="col-lg-12 col-content">
            <div class="box-float-image f-l" style="width: 326px;">
              <img src="public/images/pages/services/molde-1.jpg">
            </div>

            <h5 class="mb-2 title">¿Que es un molde de inyeccion?</h5>
            <h6 class="subtitle text-center">¿Es necesario un molde para fabricar una pieza de plástico?</h6>

            <p>
              SI,  ¡¡¡Sin molde no hay inyección!!!<br />
              Tiene gran relevancia en la calidad de la pieza.
            </p>
            
            <br />
            <p>
              En el moldeo por inyección para la elaboración de altos volúmenes de producción con una excelente calidad, es indispensable un molde de buenas cualidades, con una elaboración muy precisa, y duración aceptable. Los dos pasos más importantes en la producción de una pieza plástica son el diseño de la pieza y el diseño del molde.<br />
              El tipo de molde a elegir, para una pieza viene determinado esencialmente por consideraciones sobre el diseño del mismo.
            </p>

            <br />
            <p>
              La tarea principal del molde de inyección es recibir y distribuir el material plástico fundido, para ser formado y enfriado y posteriormente expulsar la parte moldeada.
            </p>

            <br />
            <p>
              Al diseñar el molde de inyección conviene tener en cuenta las consideraciones siguientes:
            </p>
            <ul>
              <li>
                Conocer perfectamente el plano de la pieza a moldear, establecer las líneas de partición, zona de entrada, lugar de los botadores y detalles del molde que puedan facilitar su construcción.
              </li>
              <li>
                Determinar el tipo de máquina de moldeo y el efecto que puede tener en el diseño del molde.
              </li>
              <li>
                A partir de las especificaciones del termoplástico, hay que tener en cuenta su contracción, las características de flujo y abrasión y los requisitos de calentamiento y enfriamiento.
              </li>
            </ul>

            <br />
            <p>
              Son muchos los puntos que deben de ser tomados en cuenta para la construcción de un molde: los materiales para su construcción, los métodos de elaboración del molde, diseño y características del molde y pieza a fabricar entre otros.
            </p>

            <br />
            <h6 class="subtitle">Requerimientos necesarios para un molde de inyección</h6>
            <p>
              Los principales requerimientos que debe cubrir un molde son la exactitud dimensional (dentro de las tolerancias permitidas) y la apariencia final(acabado).<br />
              El principal problema que influye en la precisión del molde es el encogimiento del material plástico. Son muchos los diferentes factores que afectan las dimensiones debidas a la contracción del producto moldeado (temperatura, presión, tiempo de enfriamiento, entre otros).<br />
              Los plásticos con una baja contracción (menos de 0,6%) usualmente no presentan problema, y las dimensiones del molde pueden ser fácilmente calculadas para dar la exactitud final de las dimensiones del producto. Con plásticos con una alta contracción (más del 0,6%) deben ser tomadas otras consideraciones importantes para el diseño del molde.
            </p>

            <br />
            <h6 class="subtitle">Materiales para la construcción de los moldes</h6>
            <p>
              En la construcción de moldes para inyección de plásticos es necesario utilizar aceros especiales por las condiciones de trabajo, debido a las cargas severas a que son sometidos y porque se requiere alta precisión en los acabados. A esto hay que añadir que las tolerancias manejadas son muy finas.<br />
              Dentro de la gran gama existente de materiales para la construcción de moldes para inyección de plásticos podemos encontrar a los aceros, materiales de colada, materiales no metálicos y materiales cerámicos.
            </p>

            <br />
            <p>
              Los aceros, utilizados en moldes para inyección deben cumplir con las siguientes características:
            </p>
            <ul>
              <li>Condiciones aceptables para su elaboración como son mecanibilidad, poder ser troquelado en frío, poder ser templado.</li>
              <li>Resistencia a la compresión</li>
              <li>Resistencia a la temperatura</li>
              <li>Resistencia a la abrasión</li>
              <li>Aptitud para el pulido</li>
              <li>Tener deformación reducida</li>
              <li>Buena conductividad térmica</li>
              <li>Buena resistencia Química</li>
              <li>Tratamiento térmico sencillo.</li>
            </ul>

            <br />
            <p>
              Dentro de los aceros para moldes podemos encontrar a los aceros de cementación, de nitruración, templados, bonificados para el empleo en el estado de suministro o resistentes a la corrosión, entre otros.<br />
              Los materiales de colada se utilizan en la fabricación de moldes con perfiles forjados o laminados. El costo de la mecanización de este tipo de molde es alto, y el tiempo empleado en la fabricación de estos moldes puede ser considerable. Hay que tener en cuenta, además que la exactitud de dimensiones y la calidad superficial son inferiores respecto a los moldes fabricados por mecanización.<br />
              Dentro de este tipo de materiales podemos encontrar a la fundición de acero y los metales no férricos.
              Los materiales no metálicos se usan en moldes para inyecciones de prueba, destinadas a obtener muestras de artículos que posteriormente vayan a ser fabricados, por lo general, el material básico es algún tipo de resina epóxica.
            </p>

            <br />
            <p>
              Los materiales cerámicos, han mostrado en recientes investigaciones las siguientes características: estabilidad con los cambios de temperatura, buen comportamiento deslizante, buena resistencia química, buena conductividad térmica. Podemos mencionar como un ejemplo el carbón sintético.
            </p>

            <br />
            <div class="box-float-image f-r" style="width: 326px;">
              <img src="public/images/pages/services/molde-2.jpg">
            </div>
            <h6 class="subtitle">El acabado</h6>

            <p>
              Los clientes suponen que la apariencia de los productos es la que se especifica en los planos. La textura que debe de tener el molde en algunas ocasiones es un aspecto que comúnmente no es tomado en cuenta. Este factor influye sobre el comportamiento del plástico.<br />
              Otro punto importante es que los acabados para los moldes son un costo adicional y suponen uno de los mayores costos de la construcción de los moldes.<br />
              Métodos de elaboración del molde.
            </p>

            <br />
            <p>
              Tan importante es el material que se utiliza para la construcción del molde como lo son los métodos que se emplean para la creación del mismo como son:<br />
              Mecanizado: puede ser dividido en dos fases, el desbaste (su objetivo es eliminar la mayor cantidad de material posible) y el mecanizado de acabado, el cual tiene como objetivo generar las superficies finales.
            </p>

            <br />
            <p>
              <strong>Estampado o troquelado:</strong> se emplea principalmente cuando hay que obtener cavidades del molde con una superficie difícil para ser elaborada por mecanizado. El punzón, estampa o troquel es elaborado exteriormente según el perfil deseado. Los elementos así obtenidos se someten a un recocido para la liberación de tensiones antes de la elaboración mecánica final, para que en el tratamiento térmico definitivo no se produzcan deformaciones.
            </p>

            <br />
            <p>
              <strong>Electroerosión:</strong> en este proceso se aprovecha el desgaste producido por descargas eléctricas breves y consecutivas. Es necesaria la creación de un electrodo, de grafito o cobre, el cual va formando las cavidades del molde. Los electrodos de grafito tienen la ventaja de tener un menor desgaste pero la desventaja de menor precisión. Los electrodos de cobre, por su parte, dan mayor precisión pero con un mayor desgaste.
            </p>

            <br />
            <p>
              <strong>Colada:</strong> en este proceso el costo de la mecanización es alto y el tiempo empleado en la fabricación del molde puede ser considerable. Hay que tener en cuenta, además que la exactitud de dimensiones y la calidad superficial son inferiores respecto a los moldes fabricados por mecanización.
            </p>

            <br />
            <h6 class="subtitle">Conclusión</h6>
            <p>
              La importancia de saber y conocer todos los puntos para la elección de la construcción de un molde para plásticos es indispensable si es que no es quiere invertir dinero en balde.
            </p>

            <br />
            <p>
              En el mercado ya existen piezas del molde como son los eyectores, columnas y manguitos de guía, placas de fijación, placas intermedias, placas para acoger a los materiales de moldeo, expulsores, placas distanciadoras, bridas de centrado, entre muchas otros que pueden adquirirse actualmente ya terminados, la producción de estas piezas es masiva por lo que los costos son menores y por consiguiente el costo del molde también baja.
            </p>

            <br />
            <p>
              El mundo de los moldes y el mundo de los plásticos, cuando se unen forman un universo en el que es fácil perderse.
            </p>

            <br />
            <p>
              Información tomada de Plásticos Universales - 58 - Agosto-Septiembre 1999 - Informe
            </p>
            <p>
              <a target="_blank" href="http://www.plastunivers.com/tecnica/hemeroteca/ArticuloCompleto.asp?ID=6229">http://www.plastunivers.com/tecnica/hemeroteca/ArticuloCompleto.asp?ID=6229</a>
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
